import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import envConfig from '../envConfig';
import Swal from 'sweetalert2';
function Register1() {
    const [activeTab, setActiveTab] = useState("home");
    const [showModal, setShowModal] = useState(false);
    const [canAccessStep2, setCanAccessStep2] = useState(false);
    const [countries, setCountries] = useState([]);
    const [adm1s, setAdm1s] = useState([]);
    const [adm2s, setAdm2s] = useState([]);
    const [adm3s, setAdm3s] = useState([]);
    const [speciesList, setSpeciesList] = useState([]);
    const [languages, setLanguages] = useState([]);
    const [preferences, setPreferences] = useState([]);
    const [formData, setFormData] = useState({
        registering_as: 'extoff',
        country_id: '',
        adm1_id: '',
        adm2_id: '',
        adm3_id: '',
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        password: '',
        confirm_password: '',
        language_id: null,
        species_id: null,
        advisory_preference_id: null,
        designation: '',
        organization: null
    });
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const isPasswordValid = (password) => {
        if (password.length < 8) return false;
        if (!/[A-Z]/.test(password)) return false;
        if (!/[a-z]/.test(password)) return false;
        if (!/[0-9]/.test(password)) return false;
        return true;
    };
    useEffect(() => {
        // Hardcode countries instead of fetching
        setCountries([
            { country_id: 1, country: "Malawi" },
            { country_id: 2, country: "Zambia" }
        ]);
        fetch(`${envConfig.API_URL}/lookups/advisory/frequency_preference`)
            .then(res => res.json())
            .then(data => setPreferences(data.data || []))
            .catch(err => console.error('Error fetching preferences:', err));
    }, []);
    const handleCountryChange = (e) => {
        const id = e.target.value;
        setFormData({ ...formData, country_id: id, adm1_id: '', adm2_id: '', adm3_id: '', language_id: null, species_id: null });
        fetch(`${envConfig.API_URL}/lookups/locations/adm1?country_id=${id}`)
            .then(res => res.json())
            .then(data => setAdm1s(data.data || []))
            .catch(err => console.error('Error fetching adm1:', err));
        fetch(`${envConfig.API_URL}/lookups/locations/adm2?country_id=${id}`)
            .then(res => res.json())
            .then(data => setAdm2s(data.data || []))
            .catch(err => console.error('Error fetching adm2:', err));
        fetch(`${envConfig.API_URL}/lookups/locations/adm3?country_id=${id}`)
            .then(res => res.json())
            .then(data => setAdm3s(data.data || []))
            .catch(err => console.error('Error fetching adm3:', err));
        fetch(`${envConfig.API_URL}/lookups/fishes/species?country_id=${id}`)
            .then(res => res.json())
            .then(data => setSpeciesList(data.data || []))
            .catch(err => console.error('Error fetching species:', err));
        fetch(`${envConfig.API_URL}/lookups/advisory/language?country_id=${id}`)
            .then(res => res.json())
            .then(data => setLanguages(data.data || []))
            .catch(err => console.error('Error fetching languages:', err));
    };
    const handleAdm1Change = (e) => {
        const id = e.target.value;
        setFormData({ ...formData, adm1_id: id, adm2_id: '', adm3_id: '' });
    };
    const handleAdm2Change = (e) => {
        const id = e.target.value;
        setFormData({ ...formData, adm2_id: id, adm3_id: '' });
    };
    const handleNext = (e) => {
        e.preventDefault();
        setCanAccessStep2(true);
        setActiveTab("profile");
    };
    const handleCancel = (e) => {
        e.preventDefault();
        setActiveTab("home");
    };
    const handleRegister = (e) => {
        e.preventDefault();
        if (formData.password !== formData.confirm_password) {
            Swal.fire({
                title: "Error!",
                text: "Passwords do not match.",
                icon: "error",
                confirmButtonText: "OK",
            });
            return;
        }
        if (!isPasswordValid(formData.password)) {
            Swal.fire({
                title: "Error!",
                text: "Password must be at least 8 characters long, contain at least one uppercase letter, one lowercase letter, and one number.",
                icon: "error",
                confirmButtonText: "OK",
            });
            return;
        }
        const payload = {
            ...formData,
            country_id: Number(formData.country_id),
            adm1_id: Number(formData.adm1_id),
            adm2_id: Number(formData.adm2_id),
            adm3_id: formData.adm3_id ? Number(formData.adm3_id) : null,
            language_id: formData.language_id ? Number(formData.language_id) : null,
            species_id: formData.species_id ? Number(formData.species_id) : null,
            advisory_preference_id: formData.advisory_preference_id ? Number(formData.advisory_preference_id) : null,
        };
        if (formData.registering_as === 'farmer') {
            payload.designation = null;
            payload.organization = null;
        }
        fetch(`${envConfig.API_URL}/auth/self_registration`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        })
            .then(async (res) => {
                const data = await res.json();
                if (!res.ok) {
                    throw new Error(data.message || 'Registration failed');
                }
                return data;
            })
            .then((data) => {
                Swal.fire({
                    title: "Success!",
                    text: data.message,
                    icon: "success",
                    confirmButtonText: "OK",
                }).then(() => {
                    setActiveTab("home");
                    setFormData({
                        registering_as: 'extoff',
                        country_id: '',
                        adm1_id: '',
                        adm2_id: '',
                        adm3_id: '',
                        first_name: '',
                        last_name: '',
                        phone: '',
                        email: '',
                        password: '',
                        confirm_password: '',
                        language_id: null,
                        species_id: null,
                        advisory_preference_id: null,
                        designation: '',
                        organization: null
                    });
                    setCanAccessStep2(false);
                    setAdm1s([]);
                    setAdm2s([]);
                    setAdm3s([]);
                    setSpeciesList([]);
                    setLanguages([]);
                });
            })
            .catch((err) => {
                Swal.fire({
                    title: "Error!",
                    text: err.message || "An error occurred during registration.",
                    icon: "error",
                    confirmButtonText: "OK",
                });
            });
    };
    return (
        <>
            <section className="">
                <div className="container-fluid">
                    <div className="row">
                        {/* Left Fixed Image Section */}
                        <div
                            className="col-sm-12 col-md-8 col-lg-8"
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                height: "100vh",
                                overflow: "hidden",
                                padding: 0,
                            }}
                        >
                            <img
                                src="./assets/images/login-img.svg"
                                alt="Fixed"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                }}
                            />
                            <div className="lightBox1">
                                <h6>What can you do?</h6>
                                <div className="d-flex justify-content-start align-items-center py-2">
                                    {/* <div><p className="mb-0">
                                    <img alt="" className="pe-1" src="./assets/images/message-square.svg" /> Send messages to Fish Farmers</p>
                                </div> */}
                                    <div>
                                        <p className="mb-0">
                                            <img alt="" className="pe-1" src="./assets/images/thermometer.svg" /> Find out local pond temperature</p>
                                    </div>
                                    <div className="ps-5"><p className="mb-0">
                                        <img alt="" className="pe-1" src="./assets/images/time.svg" /> See updates time to time</p>
                                    </div>
                                </div>
                                <p className="small mb-0">Read more about us: <a href="https://worldfishcenter.org/" target="_blank">https://worldfishcenter.org/</a></p>
                            </div>
                        </div>
                        {/* Right Data Card Section */}
                        <div
                            className="col-sm-12 col-md-4 col-lg-4 offset-lg-8 offset-md-8"
                            style={{
                                position: "relative",
                                backgroundColor: "#fff",
                                minHeight: "100vh",
                                overflowY: "auto",
                                padding: "10px 30px",
                            }}
                        >
                            {/* Header Section */}
                            <div className="logoImg mb-3">
                                <div className="d-flex justify-content-start align-items-center">
                                    <div>
                                        <img
                                            loading="lazy"
                                            alt="Logo"
                                            height="40"
                                            src="./assets/images/worldfish-logo.svg"
                                        />
                                    </div>
                                    <div className="vl"></div>
                                    <div>
                                        <h4 className="nav-title mb-0">Blue Resilience / Ulimi Wansomba</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="login-box">
                                <h1 className="nav-title-1 mb-0">Register</h1>
                                {/* Step Buttons */}
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "start",
                                        marginBottom: "10px",
                                        gap: "2px",
                                        marginTop: "10px",
                                    }}
                                >
                                    <button
                                        onClick={() => setActiveTab("home")}
                                        style={{
                                            padding: "4px 15px",
                                            background:
                                                activeTab === "home" ? "#1A4985" : "#188102",
                                            color: "#fff",
                                            border: "0px",
                                            borderRadius: "10px",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                            fontWeight: "600",
                                            lineHeight: "28px",
                                        }}
                                    >
                                        Step 1
                                    </button>
                                    <div
                                        style={{
                                            width: "35px",
                                            height: "2px",
                                            backgroundColor: "#00000080",
                                        }}
                                    ></div>
                                    <button
                                        onClick={() => {
                                            if (canAccessStep2) {
                                                setActiveTab("profile");
                                            }
                                        }}
                                        style={{
                                            padding: "4px 15px",
                                            background:
                                                activeTab === "profile"
                                                    ? "#1A4985"
                                                    : (canAccessStep2 ? "#188102" : "rgba(26, 73, 133, 0.10)"),
                                            color:
                                                activeTab === "profile"
                                                    ? "#fff"
                                                    : (canAccessStep2 ? "#fff" : "rgb(0 0 0 / 50%)"),
                                            border: "0px",
                                            borderRadius: "10px",
                                            cursor: canAccessStep2 ? "pointer" : "default",
                                            fontSize: "14px",
                                            fontWeight: "600",
                                            lineHeight: "28px",
                                        }}
                                    >
                                        Step 2
                                    </button>
                                </div>
                                {/* Step Content */}
                                <div>
                                    {activeTab === "home" && (
                                        <form className="row pt-1" onSubmit={handleNext}>
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <label className="mb-1">Registering As <span className="text-danger">*</span></label>
                                                    <select
                                                        className="form-select h40px mt-1"
                                                        name="registering_as"
                                                        value={formData.registering_as}
                                                        onChange={handleChange}
                                                        required
                                                    >
                                                        <option value="farmer">Fish Farmer</option>
                                                        <option value="extoff">Extension Officer</option>
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label className="mb-1">First Name <span className="text-danger">*</span></label>
                                                    <input
                                                        className="form-control h40px mt-1"
                                                        placeholder="Enter First Name"
                                                        name="first_name"
                                                        value={formData.first_name}
                                                        onChange={handleChange}
                                                        required
                                                        type="text"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="mb-1">Last Name <span className="text-danger">*</span></label>
                                                    <input
                                                        className="form-control h40px mt-1"
                                                        placeholder="Enter Last Name"
                                                        name="last_name"
                                                        value={formData.last_name}
                                                        onChange={handleChange}
                                                        required
                                                        type="text"
                                                    />
                                                </div>
                                                {formData.registering_as === 'extoff' && (
                                                    <>
                                                        <div className="form-group">
                                                            <label className="mb-1">Designation <span className="text-danger">*</span></label>
                                                            <input
                                                                className="form-control h40px mt-1"
                                                                placeholder="Enter Designation"
                                                                name="designation"
                                                                value={formData.designation}
                                                                onChange={handleChange}
                                                                required
                                                                type="text"
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="mb-1">Organization</label>
                                                            <input
                                                                className="form-control h40px mt-1"
                                                                placeholder="Enter Organization"
                                                                name="organization"
                                                                value={formData.organization}
                                                                onChange={handleChange}
                                                                type="text"
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                                <div className="form-group">
                                                    <label className="mb-1">Phone Number <span className="text-danger">*</span></label>
                                                    <input
                                                        className="form-control h40px mt-1"
                                                        placeholder="Enter Phone Number"
                                                        name="phone"
                                                        value={formData.phone}
                                                        onChange={handleChange}
                                                        required
                                                        type="text"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="mb-1">Email ID <span className="text-danger">*</span></label>
                                                    <input
                                                        className="form-control h40px mt-1"
                                                        placeholder="Enter Email ID"
                                                        name="email"
                                                        value={formData.email}
                                                        onChange={handleChange}
                                                        required
                                                        type="email"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="mb-1">Password <span className="text-danger">*</span></label>
                                                    <input
                                                        className="form-control h40px mt-1"
                                                        placeholder="Enter Password"
                                                        name="password"
                                                        value={formData.password}
                                                        onChange={handleChange}
                                                        required
                                                        type="password"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="mb-1">Confirm Password <span className="text-danger">*</span></label>
                                                    <input
                                                        className="form-control h40px mt-1"
                                                        placeholder="Confirm Password"
                                                        name="confirm_password"
                                                        value={formData.confirm_password}
                                                        onChange={handleChange}
                                                        required
                                                        type="password"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="row mt-3">
                                                    <div className="col-6">
                                                        <button
                                                            onClick={handleCancel}
                                                            className="btn btn-cancel1 px-4 w-100"
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>
                                                    <div className="col-6">
                                                        <button
                                                            type="submit"
                                                            className="btn btn-login1 px-4 w-100"
                                                        >
                                                            Next
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    )}
                                    {activeTab === "profile" && (
                                        <div className="pt-0">
                                            <form className="row pt-1" onSubmit={handleRegister}>
                                                <div className="col-12">
                                                    <div className="form-group">
                                                        <label className="mb-1">Country <span className="text-danger">*</span></label>
                                                        <select
                                                            className="form-select h40px"
                                                            name="country_id"
                                                            value={formData.country_id}
                                                            onChange={handleCountryChange}
                                                            required
                                                        >
                                                            <option value="">Select Country</option>
                                                            {countries.map(c => (
                                                                <option key={c.country_id} value={c.country_id}>{c.country}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="mb-1">Province <span className="text-danger">*</span></label>
                                                        <select
                                                            className="form-select h40px"
                                                            name="adm1_id"
                                                            value={formData.adm1_id}
                                                            onChange={handleAdm1Change}
                                                            required
                                                        >
                                                            <option value="">Select Province</option>
                                                            {adm1s.map(a => (
                                                                <option key={a.adm1_id} value={a.adm1_id}>{a.adm1}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="mb-1">District <span className="text-danger">*</span></label>
                                                        <select
                                                            className="form-select h40px"
                                                            name="adm2_id"
                                                            value={formData.adm2_id}
                                                            onChange={handleAdm2Change}
                                                            required
                                                        >
                                                            <option value="">Select District</option>
                                                            {adm2s.filter(a => a.adm1_id == formData.adm1_id).map(a => (
                                                                <option key={a.adm2_id} value={a.adm2_id}>{a.adm2}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="mb-1">{formData.country_id == 1 ? 'EPA' : 'Camp'} <span className="text-danger">*</span></label>
                                                        <select
                                                            className="form-select h40px"
                                                            name="adm3_id"
                                                            value={formData.adm3_id || ''}
                                                            onChange={handleChange}
                                                            required
                                                        >
                                                            <option value="">Select {formData.country_id == 1 ? 'EPA' : 'Camp'}</option>
                                                            {adm3s.filter(a => a.adm2_id == formData.adm2_id).map(a => (
                                                                <option key={a.adm3_id} value={a.adm3_id}>{a.adm3}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="mb-1">Species Preference</label>
                                                        <select
                                                            className="form-select h40px"
                                                            name="species_id"
                                                            value={formData.species_id || ''}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select Species (Optional)</option>
                                                            {speciesList.map(s => (
                                                                <option key={s.species_id} value={s.species_id}>{s.species}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="mb-1">Language Preference</label>
                                                        <select
                                                            className="form-select h40px"
                                                            name="language_id"
                                                            value={formData.language_id || ''}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select Language (Optional)</option>
                                                            {languages.map(l => (
                                                                <option key={l.language_id} value={l.language_id}>{l.language}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="mb-1">Advisory Preference</label>
                                                        <select
                                                            className="form-select h40px"
                                                            name="advisory_preference_id"
                                                            value={formData.advisory_preference_id || ''}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select Preference (Optional)</option>
                                                            {preferences.map(p => (
                                                                <option key={p.advisory_preference_id} value={p.advisory_preference_id}>{p.preference}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="row mt-3">
                                                        <div className="col-6">
                                                            <button
                                                                onClick={handleCancel}
                                                                className="btn btn-cancel1 px-4 w-100"
                                                            >
                                                                Cancel
                                                            </button>
                                                        </div>
                                                        <div className="col-6">
                                                            <button
                                                                type="submit"
                                                                className="btn btn-login1 px-4 w-100"
                                                            >
                                                                Register
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    )}
                                </div>
                                <p className="text-center mb-0 my-1">
                                    <small>
                                        Already have an account? <Link to="/login">Login</Link>
                                    </small>
                                </p>
                                {/* Footer Logos */}
                                <div className="loginFooterLogo mt-2">
                                    <div className="d-flex justify-content-center">
                                        <img
                                            alt=""
                                            height="35px"
                                            src="./assets/images/login-footer-1.svg"
                                        />
                                        <img
                                            className="ms-2"
                                            alt=""
                                            height="35px"
                                            src="./assets/images/sadc.png"
                                        />
                                        <img
                                            height="35px"
                                            alt=""
                                            src="./assets/images/top-login-logo.svg"
                                        />
                                        <img
                                            className="mx-2"
                                            height="35px"
                                            src="./assets/images/footer-2.png"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
export default Register1;